import React, { useState, useEffect, useRef } from 'react';
import $ from 'jquery';
import { Button, Container, Row, Col, Card, Table, Spinner, Modal, Form } from 'react-bootstrap';
import "bootstrap/dist/css/bootstrap.min.css"; 
import "datatables.net-bs5/css/dataTables.bootstrap5.min.css"; 
import "datatables.net-responsive-bs5/css/responsive.bootstrap5.min.css"; 
import "datatables.net-bs5";
import "datatables.net-responsive-bs5";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import * as XLSX from 'xlsx'; 
import Header from '../Header';

const ManageTickets = () => {
   const [tickets, setTickets] = useState([]);
   const [employees, setEmployees] = useState([]);
   const [loading, setLoading] = useState(true); 
   const [error, setError] = useState(null);
   const [successMessage, setSuccessMessage] = useState(null); 
   const [showModal, setShowModal] = useState(false); 
   const [selectedTicket, setSelectedTicket] = useState(null); 
   const [selectedEmployee, setSelectedEmployee] = useState(''); 
   const [empTicket, setEmpTicket] = useState(null);
   const tableRef = useRef(null);
   const id = localStorage.getItem('userId');  
   const navigate = useNavigate();
   

   useEffect(() => {
       const fetchLeads = async () => {
         try {
          const response = await fetch(`https://apiaksharaconnect.aksharafinalytics.in/showticket/${id}`);
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }          
          const result = await response.json();  
          setTickets(result.ticket || []); 
          console.log(result);
          
   
           const empResponse = await fetch(`https://apiaksharaconnect.aksharafinalytics.in/employee/${id}`);
           const empData = await empResponse.json();
          // console.log(empData);
           setEmployees(empData || []);     
   
           if (!response.ok) {
             throw new Error('Failed to fetch leads');
           }
          
         } catch (error) {
           setError(error.message);
         } finally {
           setLoading(false);
         }
       };
   
       fetchLeads();
     }, []);

   useEffect(() => {
     if (tickets.length > 0 && tableRef.current) {
       const table = $(tableRef.current).DataTable({
         responsive: true,
         autoWidth: false,
         destroy: true, 
         paging: true,
         pageLength: 10, 
         lengthMenu: [10, 25, 50, 100], 
         columnDefs: [
           { targets: 0, responsivePriority: 1 },
           { targets: 1, responsivePriority: 2 },
           { targets: 2, responsivePriority: 3 },
           { targets: 3, responsivePriority: 4 },
           { targets: 4, responsivePriority: 5 },
           { targets: 5, responsivePriority: 6 },
           { targets: 6, responsivePriority: 7 },
         ],
       });
   
       return () => {
         table.destroy(); // Cleanup on unmount
       };
     }
   }, [tickets]);

   const exportToExcel = () => {
       if (tickets.length === 0) {
         alert("No data to export");
         return;
       }
   
       const ws = XLSX.utils.json_to_sheet(tickets);
       const wb = XLSX.utils.book_new();
       XLSX.utils.book_append_sheet(wb, ws, "tickets");
   
       XLSX.writeFile(wb, "Tickets_List.xlsx");
     };


     const handleAssignButtonClick = (ticket) => {
      setEmpTicket(ticket);
      setShowModal(true); // Show the modal
    };

    const handleAssignSubmit = async (ticket) => {
      if (!selectedEmployee) {
        return;
      }
      setLoading(true);
    
      try {
        const payload = {
          emp_id: selectedEmployee,
        };
    
        const response = await fetch(`https://apiaksharaconnect.aksharafinalytics.in/assignticket/${ticket.id}`, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(payload),
        });
    
        const responseData = await response.json();
        
    
        setSuccessMessage('Task assigned successfully!');
        setError(null);
    
        // Close the modal and reset form
        setShowModal(false);
        setSelectedEmployee('');
    
        // Optional: Reload after delay
        setTimeout(() => {
          setSuccessMessage(null);
          window.location.reload();
        }, 3000);
      } catch (error) {
        console.error('Error assigning ticket:', error);
        setError(error.message);
        setSuccessMessage(null);
      } finally {
        setLoading(false); // Stop submitting
      }
    };
    
    

   

   const openUpdateStatusModal = (ticket) => {
    setSelectedTicket(ticket);
  };

  const handleUpdateStatus = async (e) => {
    e.preventDefault();
    setLoading(true);
    const { ticket_id, emp_query, status, file ,user_id} = e.target.elements;
  
    const formData = new FormData();
    formData.append('emp_query', emp_query.value);
    formData.append('status', status.value);
    formData.append('ticket_id', ticket_id.value);
    formData.append('user_id', user_id.value);

    // If there's a file selected, append it to FormData, otherwise append null (backend may handle this)
    if (file.files[0]) {
        formData.append('file', file.files[0]);
    } else {
        formData.append('file', '');  // Use an empty string to handle no file selection
    }
  
    try {
      const response = await fetch(`https://apiaksharaconnect.aksharafinalytics.in/Tquery`, {
        method: 'POST',
        body: formData,
      });
  
      const contentType = response.headers.get("content-type");
      let responseData = {};
  
      if (!response.ok) {
        if (contentType && contentType.includes("application/json")) {
          const errorResponse = await response.json();
          throw new Error(errorResponse.message || 'Failed to update ticket');
        } else {
          throw new Error('Failed to update ticket');
        }
      }
  
      if (contentType && contentType.includes("application/json")) {
        responseData = await response.json();
      }

      console.log(responseData);
  
      setSuccessMessage('Ticket status updated successfully');
      setTimeout(() => {
        setSuccessMessage(null);
        window.location.reload();
      }, 5000);
    } catch (error) {
      console.error('Error updating ticket:', error);
      setError(error.message);
      setSuccessMessage(null);
    } finally {
      setSelectedTicket(null);
      setLoading(false);
    }
  };   

   if (loading) {
     return (
       <Container fluid className="d-flex justify-content-center align-items-center" style={{ minHeight: '100vh' }}>
         <Spinner animation="border" variant="primary" />
       </Container>
     );
   }

   return (
     <>
       <Header />
       <Container fluid className="shadow mx-1 px-3 bg-light rounded-3">
         <Row className="d-flex align-items-center justify-content-between p-3 mt-3">
           <Col>
             <h4 className="mb-0">All Tickets</h4>
           </Col>
           <Col className="text-end">
             <Button variant="success" onClick={exportToExcel}>
               Export to Excel
             </Button>
           </Col>
         </Row>

         {error && <div className="alert alert-danger">{error}</div>}
        {successMessage && <div className="alert alert-success">{successMessage}</div>}

         <Card>
           <Card.Header>Tickets List</Card.Header>
           <Card.Body>
             <div className="table-responsive">
               <Table ref={tableRef} striped bordered hover responsive>
                 <thead>
                   <tr>
                     <th>S.no</th>
                     <th>Ticket Id</th>
                     <th>User</th>
                     <th>Plan</th>
                     <th>Subject</th>
                     <th>Description</th>
                     <th>Emp Description</th>
                     <th>Emp File</th>
                     <th>File</th>
                     <th>Raise By</th>
                     <th>Transfer To</th>
                     <th>Status</th>                    
                     <th>Assign To</th>
                     <th>Assigned On </th>
                     <th>Closed On</th>
                     <th>Raised On</th>
                     <th>View</th>
                   </tr>
                 </thead>
                 <tbody>
                   {tickets.length > 0 ? (
                     tickets.map((ticket, index) => (
                       <tr key={ticket.id}>
                         <td>{index + 1}</td>
                         <td className="text-danger">{ticket.ticket_id || 'N/A'}</td>
                         <td className="text-primary">{ticket.Username || 'N/A'}</td>
                         <td>{ticket.Plan || 'N/A'}</td>
                         <td>{ticket.Subject || 'N/A'}</td>
                         <td>{ticket.Description || 'N/A'}</td>
                         <td>{ticket.emp_Description || 'N/A'}</td>
                         
                         <td>
                           {ticket.emp_file ? (
                             <a href={`https://apiaksharaconnect.aksharafinalytics.in/${ticket.emp_file}`} download={ticket.emp_file} target='_blank'>
                               <button className="btn btn-warning ms-2 p-1 m-1"><FontAwesomeIcon icon={faDownload} /> </button>
                             </a>
                           ) : (
                             <span>N/A</span>
                           )}
                         </td>
                          <td>
                           {ticket.file ? (
                             <a href={`https://apiaksharaconnect.aksharafinalytics.in/${ticket.file}`} download={ticket.file} target='_blank'>
                               <button className="btn btn-warning ms-2 p-1 m-1"><FontAwesomeIcon icon={faDownload} /> </button>
                             </a>
                           ) : (
                             <span>N/A</span>
                           )}
                         </td>
                         <td className="text-primary">{ticket.RaisedByEmpName || ticket.Username}</td>
                         <td className="text-success">{ticket.TransferEmpName || 'N/A'}</td>
                         <td className={ticket.status === 'closed' ? 'text-danger' : 'text-primary'}>
                            {ticket.status || 'N/A'}
                        </td>
                         <td>
                         {ticket.EmpName ? (
                                <span className="text-primary">{ticket.EmpName}</span>
                              ) : (
                                ticket.status === 'in-progress' || ticket.status === 'open' ? (
                                  <>
                                    <button className="btn btn-primary ms-2 p-1 m-1" onClick={() => handleAssignButtonClick(ticket)}>
                                      Assign
                                    </button>
                                    {/* <button className="btn btn-info" onClick={() => openUpdateStatusModal(ticket)}>
                                      Update Status
                                    </button> */}
                                  </>
                                ) : null 
                              )}                                                 
                         </td>
                         <td>{ticket.assigned_date || 'N/A'}</td>
                         <td>{ticket.closed_date || 'N/A'}</td> 
                         <td>{ticket.doa || 'N/A'}</td>   
                         <td>
                          <button className="btn btn-primary" onClick={() => navigate(`/Tqueries/${ticket.ticket_id}`)}>
                              View
                          </button>
                        </td>                     
                       </tr>
                     ))
                   ) : (
                     <tr>
                       <td colSpan="9" className="text-center">No Tickets available</td>
                     </tr>
                   )}
                 </tbody>
               </Table>
             </div>
           </Card.Body>
         </Card>


         {selectedTicket && (
  <div className="modal fade show" tabIndex="-1" style={{ display: 'block' }} aria-modal="true" role="dialog">
    <div className="modal-dialog">
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title">Update Ticket Status</h5>
          <button
            type="button"
            className="btn-close"
            onClick={() => setSelectedTicket(null)}
            aria-label="Close"
          ></button>
        </div>
        <div className="modal-body">
          <form onSubmit={handleUpdateStatus}>
            {/* Hidden Fields */}
            <input type="hidden" name="user_id" defaultValue={selectedTicket.user_id || ''} />
            <input type="hidden" name="ticket_id" defaultValue={selectedTicket.ticket_id || ''} />

            {/* Description */}
            <div className="mb-3">
              <label className="form-label">Description</label>
              <textarea
                className="form-control"
                name="emp_query"
                defaultValue={selectedTicket.emp_Description || ''}
                required
              ></textarea>
            </div>

            {/* File Upload */}
            <div className="mb-3">
              <label className="form-label">Attach File</label>
              <input type="file" className="form-control" name="file" />
              {selectedTicket.emp_file && (
                <small className="text-muted d-block mt-1">
                  Current file: {selectedTicket.emp_file.name || selectedTicket.emp_file}
                </small>
              )}
            </div>

            {/* Status */}
            <div className="mb-3">
              <label className="form-label">Status</label>
              <select  className="form-select"  name="status" defaultValue={selectedTicket.status || ''} required>
                <option value="">-- Select Status --</option>
                <option value="in-progress">Open</option>
                <option value="closed">Closed</option>
              </select>
            </div>

            <button type="submit" className="btn btn-primary" disabled={loading}>
                {loading ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                    updating...
                  </>
                ) : (
                  'update'
                )}
              </button>
          </form>
        </div>
      </div>
    </div>
  </div>
)}


         {/* Modal for assigning the ticket */}
         <Modal show={showModal} onHide={() => setShowModal(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Assign Ticket</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Form.Group controlId="assignTo">
                <Form.Label>Assign To</Form.Label>
                <Form.Control
                  as="select"
                  name="emp_id"
                  value={selectedEmployee}
                  onChange={(e) => setSelectedEmployee(e.target.value)}
                >
                  <option value="">Select Employee</option>
                  {Array.isArray(employees) &&
                    employees.map((employee) => (
                      <option key={employee.id} value={employee.id}>
                        {employee.name}
                      </option>
                    ))}
                </Form.Control>
              </Form.Group>
            </Form>
            {error && <div className="text-danger mt-2">{error}</div>}
            {successMessage && <div className="text-success mt-2">{successMessage}</div>}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowModal(false)}>
              Close
            </Button>
            <Button variant="primary" onClick={() => handleAssignSubmit(empTicket)} disabled={loading}>
              
              {loading ? 'Assigning...' : 'Assign Ticket'}
            </Button>             
          </Modal.Footer>
        </Modal>
       </Container>
     </>
   );
};

export default ManageTickets;
